// Preset avatars living in client/public/assets/avatars/<category>/.
// Users pick one instead of uploading pictures. Stored on the user as
// "<category>/avatar-NN.jpg" — keep categories and counts in sync with
// the folders and with the server-side limits in
// nodeapi/validator/avatar.js.

const ASSETS = `${process.env.PUBLIC_URL}/assets`

const buildSet = (category, count) =>
  Array.from(
    { length: count },
    (_, i) => `${category}/avatar-${String(i + 1).padStart(2, "0")}.jpg`
  )

export const AVATAR_CATEGORIES = [
  { id: "real", label: "REAL" },
  { id: "comic", label: "COMIC" }
]

export const AVATARS_BY_CATEGORY = {
  real: buildSet("real", 20),
  comic: buildSet("comic", 22)
}

// Category an avatar path belongs to (e.g. "comic/avatar-03.jpg" →
// "comic"); defaults to the first category.
export const categoryOf = name => {
  const prefix = (name || "").split("/")[0]
  return AVATARS_BY_CATEGORY[prefix] ? prefix : AVATAR_CATEGORIES[0].id
}

export const avatarUrl = name => `${ASSETS}/avatars/${name}`

export const DEFAULT_AVATAR = `${ASSETS}/avatarm.png`
